import { CalculatedColumn } from "react-data-grid";

export * from "./colSpanUtils";
export * from "./domUtils";
export * from "./keyboardUtils";
export * from "./selectedCellUtils";
export * from "./styleUtils";

export const { min, max, round, floor, sign, abs, ceil } = Math;

export function assertIsValidKeyGetter<R, K extends React.Key>(
  keyGetter: unknown
): asserts keyGetter is (row: R) => K {
  if (typeof keyGetter !== "function") {
    throw new Error("Please specify the rowKeyGetter prop to use selection");
  }
}

export function clampColumnWidth<R, SR>(
  width: number,
  { minWidth, maxWidth }: CalculatedColumn<R, SR>
): number {
  width = max(width, minWidth);

  // ignore maxWidth if it less than minWidth
  if (typeof maxWidth === "number" && maxWidth >= minWidth) {
    return min(width, maxWidth);
  }

  return width;
}
